'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_data_auth$package$IsUserAdmin$() {
  this.Lapp_data_auth$package$IsUserAdmin$__f_defaultMake$lzy2 = null;
  this.Lapp_data_auth$package$IsUserAdmin$__f_defaultMakebitmap$2 = false;
  this.Lapp_data_auth$package$IsUserAdmin$__f_make$lzy2 = null;
  this.Lapp_data_auth$package$IsUserAdmin$__f_makebitmap$2 = false;
  this.Lapp_data_auth$package$IsUserAdmin$__f_given_Conversion_Type_Boolean$lzy1 = null;
  this.Lapp_data_auth$package$IsUserAdmin$__f_given_Conversion_Type_Booleanbitmap$1 = false;
}
export { $c_Lapp_data_auth$package$IsUserAdmin$ as $c_Lapp_data_auth$package$IsUserAdmin$ };
$c_Lapp_data_auth$package$IsUserAdmin$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_data_auth$package$IsUserAdmin$.prototype.constructor = $c_Lapp_data_auth$package$IsUserAdmin$;
/** @constructor */
function $h_Lapp_data_auth$package$IsUserAdmin$() {
}
export { $h_Lapp_data_auth$package$IsUserAdmin$ as $h_Lapp_data_auth$package$IsUserAdmin$ };
$h_Lapp_data_auth$package$IsUserAdmin$.prototype = $c_Lapp_data_auth$package$IsUserAdmin$.prototype;
$c_Lapp_data_auth$package$IsUserAdmin$.prototype.defaultMake__Lyantl_INewtype$defaultMake$ = (function() {
  if ((!this.Lapp_data_auth$package$IsUserAdmin$__f_defaultMakebitmap$2)) {
    this.Lapp_data_auth$package$IsUserAdmin$__f_defaultMake$lzy2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lyantl_INewtype$defaultMake$(this);
    this.Lapp_data_auth$package$IsUserAdmin$__f_defaultMakebitmap$2 = true;
  }
  return this.Lapp_data_auth$package$IsUserAdmin$__f_defaultMake$lzy2;
});
$c_Lapp_data_auth$package$IsUserAdmin$.prototype.make__Lyantl_INewtype$make$ = (function() {
  if ((!this.Lapp_data_auth$package$IsUserAdmin$__f_makebitmap$2)) {
    this.Lapp_data_auth$package$IsUserAdmin$__f_make$lzy2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lyantl_INewtype$make$(this);
    this.Lapp_data_auth$package$IsUserAdmin$__f_makebitmap$2 = true;
  }
  return this.Lapp_data_auth$package$IsUserAdmin$__f_make$lzy2;
});
$c_Lapp_data_auth$package$IsUserAdmin$.prototype.resolveMake__Lyantl_Make = (function() {
  return this.defaultMake__Lyantl_INewtype$defaultMake$();
});
$c_Lapp_data_auth$package$IsUserAdmin$.prototype.protected_unwrap__O__O = (function(wrapped) {
  return wrapped;
});
$c_Lapp_data_auth$package$IsUserAdmin$.prototype.wrap__O__O = (function(underlying) {
  return underlying;
});
$c_Lapp_data_auth$package$IsUserAdmin$.prototype.validate__Lyantl_Validate = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lyantl_Validate$().Lyantl_Validate$__f_noOp;
});
$c_Lapp_data_auth$package$IsUserAdmin$.prototype.given_Conversion_Type_Boolean__s_Conversion = (function() {
  if ((!this.Lapp_data_auth$package$IsUserAdmin$__f_given_Conversion_Type_Booleanbitmap$1)) {
    this.Lapp_data_auth$package$IsUserAdmin$__f_given_Conversion_Type_Boolean$lzy1 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_utils_NewtypeBoolean$$anon$2(this);
    this.Lapp_data_auth$package$IsUserAdmin$__f_given_Conversion_Type_Booleanbitmap$1 = true;
  }
  return this.Lapp_data_auth$package$IsUserAdmin$__f_given_Conversion_Type_Boolean$lzy1;
});
var $d_Lapp_data_auth$package$IsUserAdmin$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_data_auth$package$IsUserAdmin$, "app.data.auth$package$IsUserAdmin$", ({
  Lapp_data_auth$package$IsUserAdmin$: 1,
  Lyantl_INewtype: 1,
  Lyantl_Newtype: 1,
  Lyantl_Newtype$Of: 1,
  Lyantl_Newtype$WithoutValidation: 1,
  Lyantl_Newtype$WithoutValidationOf: 1,
  Lframework_utils_NewtypeBoolean: 1
}));
export { $d_Lapp_data_auth$package$IsUserAdmin$ as $d_Lapp_data_auth$package$IsUserAdmin$ };
var $n_Lapp_data_auth$package$IsUserAdmin$;
function $m_Lapp_data_auth$package$IsUserAdmin$() {
  if ((!$n_Lapp_data_auth$package$IsUserAdmin$)) {
    $n_Lapp_data_auth$package$IsUserAdmin$ = new $c_Lapp_data_auth$package$IsUserAdmin$();
  }
  return $n_Lapp_data_auth$package$IsUserAdmin$;
}
export { $m_Lapp_data_auth$package$IsUserAdmin$ as $m_Lapp_data_auth$package$IsUserAdmin$ };
//# sourceMappingURL=app.data.auth$package$-Is-User-Admin$.js.map
